import { Controller } from "@hotwired/stimulus"
// import * as Turbo from "@hotwired/turbo"
import { gsap } from "gsap"
import { isTouchDevice, debounce } from '../helpers'


export default class extends Controller {
  static targets = [ "select","filterContainer","filterTrigger", "cancelFilter" ]

  initialize() {
    if(this.selectTargets.length){
      this.setupSelect(this.selectTargets[0])
      this.setCurrentSort()
      if(window.location.href.split('?')[1]){
        this.scrollBelowHeader()
      }
    }
    if(this.filterTriggerTargets.length){
      this.setupFilter(this.filterTriggerTargets[0])
    }
  }

  scrollBelowHeader(){
    setTimeout(()=>{
      const sortClientBoundingRect = this.selectTargets[0].getBoundingClientRect()
      const headerClientBoundingRect = document.querySelector('.main-header').getBoundingClientRect()
      const scrollOffset = sortClientBoundingRect.top - headerClientBoundingRect.height + 8
      window.scrollTo({
        top: scrollOffset
      });
    },100)
  }

  setCurrentSort(){
    const queryParams = window.location.search

    if(queryParams){
      const currentValue = queryParams.split('=')[1]
      this.selectTargets[0].querySelectorAll("option").forEach((el)=>{
        const value = el.value;
        el.selected = ''
        console.log(value, currentValue)
        if(value == currentValue){
          el.selected = 'selected'
        }
      })
    }
  }

  setupSelect(el){
    el.addEventListener('change', function(e) {
      const value = e.target.value;
      const cleanURL = window.location.href.split('?')[0]
      const queryParamsTemplate = '?sort_by='
      const sortURL = cleanURL + queryParamsTemplate + value

      if(sortURL){
        window.location.href = sortURL
      }
    });
  }

  setupFilter(el){
    el.addEventListener('click', (e)=>{
      if(e.target.nodeName != 'A' && !e.target.closest('a')){
        this.filterContainerTargets[0].classList.add('active')
        window.dispatchEvent(new CustomEvent('scroll'))
      }
    })
    this.cancelFilterTargets[0].addEventListener('click', (e)=>{
      this.filterContainerTargets[0].classList.remove('active')
      this.scrollBelowHeader()
    })
  }

}